export const execute = (provider) => (business) => {
    return provider.getAll(business)
    .then(sort)
}

const sort = (branch) => {
    return branch.sort((s1, s2) => s1.name.toLowerCase() > s2.name.toLowerCase() ? 1 : -1);
}
